import { ChevronDownIcon, CloseIcon, InfoOutlineIcon } from '@chakra-ui/icons';
import {
    Box,
    Button,
    ButtonGroup,
    Divider,
    Flex,
    Icon,
    IconButton,
    Image,
    Input,
    Link,
    Menu,
    MenuButton,
    MenuItem,
    MenuList,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
    Radio, RadioGroup,
    Select,
    Switch,
    Table,
    Tbody,
    Td,
    Text,
    Textarea,
    Th,
    Thead,
    Tooltip,
    Tr,
    useColorModeValue,
    useDisclosure,
    useToast,
} from '@chakra-ui/react';
import BuildUrlParamsUpdate from 'components/adspresso/BuildUrlParamsUpdate';
import UrlParametersUpdate from 'components/adspresso/UrlParametersUpdate';
import AiImageModal from 'components/aiHub/AiImageModal';
import AiVideoModal from 'components/aiHub/AiVideoModal';
import DriveComponent from 'components/drive/DriveComponent';
import ReplaceDriveModal from 'components/drive/ReplaceDriveModal';
import MessageTemplateModal from 'components/genericForms/MessageTemplateModal';
import ReplaceComponentForSingle from 'components/genericForms/ReplaceComponentForSingle';
import { useFormik } from 'formik';
import { useEffect, useState } from 'react';
import { BsStars } from 'react-icons/bs';
import { FaExchangeAlt } from 'react-icons/fa';
import { FiPhoneCall } from 'react-icons/fi';
import { IoBuildOutline } from 'react-icons/io5';
import { MdDeleteOutline, MdOutlineEdit } from 'react-icons/md';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { useSelector } from "react-redux";
import { selectCallsData, selectLandersData } from 'store/aiHub/aiSlice';
import { useCreateAdMutation, useGetInstantFormsByPageIdQuery } from 'store/campaigns/adsApi';
import { selectSelectedAdset } from 'store/campaigns/campaignsSlice';
import {
    call_to_action_options,
    call_to_action_options_app_promptions,
    call_to_action_options_for_app_leads_and_sales,
    call_to_action_options_instantForms,
    call_to_action_options_whatsapp
} from 'utils/callToActions';
import { getStepMeta, removeEmptyValues, StepButton } from 'utils/functions';
import imagePlacementConfig from 'utils/imagePlacementConfig.json';
import videoPlacementConfig from 'utils/videoPlacementConfig.json';
import * as Yup from 'yup';

const CreateSingleAdForm = ({ onFormValuesChange, adFormik, objective, adsAccountData, onSuccess, onClose, onSave }) => {

    const toast = useToast();
    const background = useColorModeValue('gray.50', 'gray.800');
    const buttonBackgroundColor = useColorModeValue('gray.50', 'gray.800');
    const boxBorder = useColorModeValue("gray.300", "purple.800");
    const backgroundColor = useColorModeValue('#F5F3F9', '#1e1530');
    const bgGradient = useColorModeValue(
        "linear-gradient(180deg, #f8f6fb 10%, #b0a8bf 130%)", 
        "linear-gradient(180deg, #1a202c 10%, #1b1845 130%)"   
      );
    const bgInput = useColorModeValue('#f8f6fb', '#1e1530');
    const ListBgColor = useColorModeValue('#fff', 'gray.800');
    const hoverBorder = useColorModeValue('gray.50', 'gray.700');
    const [activeStep, setActiveStep] = useState("Media"); // 'Media' | 'Replace'
    const [hasSelectedFiles, setHasSelectedFiles] = useState(false);
    const [mediaType, setMediaType] = useState(null);
    const { isOpen: isEditMediaOpen, onOpen: OnEditMediaOpen, onClose: OnEditMediaClose } = useDisclosure();
    const { isOpen: isReplaceModalOpen, onOpen: OnReplaceModalOpen, onClose: OnReplaceModalClose } = useDisclosure();
    const { isOpen: isAiImageModaOpen, onOpen: onAiImageModalOpen, onClose: onAiImageModalClose } = useDisclosure();
    const { isOpen: isAiVideoModalOpen, onOpen: onAiVideoModalOpen, onClose: onAiVideoModalClose } = useDisclosure();
    const { isOpen: isMessageModalOpen, onOpen: onMessageModalOpen, onClose: onMessageModalClose } = useDisclosure();
    const { isOpen: isCreativeModalOpen, onOpen: onCreativeModalOpen, onClose: onCreativeModalClose} = useDisclosure();
    const selectedAdset = useSelector(selectSelectedAdset);
    const callsData = useSelector(selectCallsData);
    const landersData = useSelector(selectLandersData);
    const userInfo = useSelector((state) => state.auth?.userInfo);
    const [selectedMediaUrls, setselectedMediaUrls] = useState([]);
    const [activePlacement, setActivePlacement] = useState(null);
    const [isUrlModalOpen, setUrlModalOpen] = useState(false);
    const [isUrlParamModalOpen, setUrlParamModalOpen] = useState(false);
    const [prevAdFormikValues, setPrevAdFormikValues] = useState(adFormik.values);
    const [showSavedPhones, setShowSavedPhones] = useState(false);
    const [showSavedLanders, setShowSavedLanders] = useState(false);

    const [createAd] = useCreateAdMutation();

    const pageId = adFormik?.values?.page_id;

    const formattedPageIds = (Array.isArray(pageId) ? pageId : [pageId]).filter(Boolean);

    const { data: instantForms } = useGetInstantFormsByPageIdQuery(
        { pageIds: formattedPageIds },
        { skip: !formattedPageIds.length || !['ON_AD', 'WEBSITE_AND_LEAD_FORM'].includes(selectedAdset?.destination_type)}
    );

    const validationSchema = Yup.object().shape({
        name: Yup.string().required('Name is required'),
        cpa: Yup.number()
            .typeError('must be a number')
            .positive('must be a positive number'),
        creative: Yup.object().shape({
            object_story_spec: Yup.object().shape({
                link_data: Yup.object().shape({
                    destination_type: Yup.string(),
                    link: Yup.string()
                        .when('destination_type', {
                            is: (value) => ['WEBSITE', 'WEBSITE_AND_PHONE_CALL', 'WEBSITE_AND_LEAD_FORM'].includes(value),
                            then: () => Yup.string()
                                .required('URL is required'),
                            otherwise: () => Yup.string().notRequired(),
                        }),
                    call_to_action: Yup.object().shape({
                        type: Yup.string().required('Call to action type is required'),
                        value: Yup.object().shape({
                            destinationType: Yup.string(),
                            link: Yup.string()
                                .when('destinationType', {
                                    is: (value) => ['PHONE_CALL', 'WEBSITE_AND_PHONE_CALL'].includes(value),
                                    then: () => Yup.string()
                                        .transform((value) => value.slice(2)) // Remove the first two digits (e.g., country code like "91")
                                        .matches(/^[0-9]{10,15}$/, 'Phone number must be at least 10 digits') // Ensure remaining digits are at least 10 digits
                                        .required('Phone number is required'), // Ensure phone number is provided
                                    otherwise: () => Yup.string().notRequired(),
                                }),
                            lead_gen_form_id: Yup.string()
                                .when('destinationType', {
                                    is: (value) => ['ON_AD', 'WEBSITE_AND_LEAD_FORM'].includes(value),
                                    then: () => Yup.string()
                                        .required('Instant form is required'),
                                    otherwise: () => Yup.string().notRequired(),
                                }),
                        }),
                    }),
                }),
                page_id: Yup.string().required('Facebook page is required')
            }),
        }),
        image_url: Yup.string()
            .required('Creative is required'),
    });

    const determineType = () => {
        if (selectedAdset?.destination_type === 'WEBSITE') return 'SHOP_NOW';
        if (selectedAdset?.destination_type === 'PHONE_CALL') return 'CALL_NOW';
        if (selectedAdset?.destination_type === 'WHATSAPP') return 'WHATSAPP_MESSAGE';
        if (selectedAdset?.destination_type === 'APP') {
          if (objective === 'OUTCOME_APP_PROMOTION') return 'INSTALL_MOBILE_APP';
          if (['OUTCOME_SALES', 'OUTCOME_LEADS'].includes(objective)) return 'USE_MOBILE_APP';
        }
        return 'SIGN_UP';
    }; 

    const formik = useFormik({
        initialValues: {
            name: adFormik.values.name || '',
            hash: '',
            cpa: '',
            adType: 'image',
            creative: {
                name: '',
                url_tags: '',
                website_url: selectedAdset?.promoted_object?.object_store_url,
                app_product_page_id: '',
                object_story_spec: {
                    link_data: {
                        destination_type: selectedAdset?.destination_type ? selectedAdset?.destination_type : '',
                        call_to_action: {
                            type: determineType(),
                            value: {
                                destinationType: selectedAdset?.destination_type ? selectedAdset?.destination_type : '',
                                link: '',
                                lead_gen_form_id: ''
                            },
                        },
                        caption: '',
                        message: '',
                        name: '',
                        description: '',
                        link: '',
                        image_hash: '',
                        video_id: ''
                    },
                    page_id: adFormik.values?.page_id,
                    instagram_user_id: adFormik.values?.instagram_user_id,
                },
            },
            page_welcome_message: {
                type: 'VISUAL_EDITOR',
                version: 2,
                landing_screen_type: 'welcome_message',
                media_type: 'text',
                surface: 'visual_editor_new',
                user_edit: false,
                text_format: {
                  customer_action_type: 'autofill_message',
                  message: {
                    text: "Hi! Please let us know how we can help you.",
                    autofill_message: {
                      content: "Hello! Can I get more info on this?",
                    },
                  },
                }
            },
            enroll_status: adFormik.values.enroll_status ? adFormik.values.enroll_status : 'OPT_OUT',
            pac_relaxation_enroll_status : 'OPT_IN',
            image_url: '',
            picture: '',
        },
        validationSchema,
        enableReinitialize: true,
        onSubmit: (values, { setSubmitting }) => {

            const formatPhoneNumber = (phoneNumber) => {

                if (!phoneNumber.startsWith('tel:+')) {
                    return `tel:+${phoneNumber}`;
                }
                return phoneNumber;
            };

            const allUrlsMatch = selectedMediaUrls?.every(
                (item) => item.hash === selectedMediaUrls[0]?.hash
            );

            const storySpec = {
                page_id: values.creative.object_story_spec.page_id,
                instagram_user_id: values.creative.object_story_spec.instagram_user_id
            };

            const contextual_multi_ads = {
                enroll_status: values?.enroll_status
            }

            // Step 1: Create a hash -> { mediaType, placement } map
            const hashMap = {};
            selectedMediaUrls?.forEach(item => {
                hashMap[item.hash] = {
                    mediaType: item.mediaType,
                    placement: item.placement
                };
            });

            // Step 2: Deduplicate mediaData based on hash
            const seenHashes = new Set();
            const hashDuplicates = new Map();

            // First pass: gather duplicates by hash
            selectedMediaUrls?.forEach(item => {
                if (seenHashes.has(item.hash)) {
                    if (!hashDuplicates.has(item.hash)) {
                        hashDuplicates.set(item.hash, []);
                    }
                    hashDuplicates.get(item.hash).push(item.placement);
                } else {
                    seenHashes.add(item.hash);
                }
            });

            // Reset seenHashes to reuse it
            seenHashes.clear();

            // Second pass: build mediaData with tags
            const mediaData = selectedMediaUrls?.filter(item => {
                if (seenHashes.has(item.hash)) return false;
                seenHashes.add(item.hash);
                return true;
            })
                .map(item => {
                    const duplicatePlacements = hashDuplicates.get(item.hash);
                    const tag = duplicatePlacements?.length
                        ? { duplicatePlacements }
                        : undefined;

                    return {
                        [item.mediaType === 'image' ? 'hash' : 'video_id']: item.hash,
                        [item.mediaType === 'image' ? 'creative_hash' : 'hash']: item.mediaHash,
                        mediaType: item.mediaType,
                        adlabels: [{ name: item.placement }],
                        ...(tag && { tag })
                    };
                });

            // Remove 'tag' before assigning
            const cleanedMediaData = mediaData?.map(({ tag, mediaType, ...rest }) => rest);

            // Step 3: Build asset_customization_rules using hashMap
            const asset_customization_rules = [];

            mediaData?.forEach(media => {
                const meta = hashMap[media.mediaType === 'image' ? media.hash : media.video_id];
                if (!meta) return; // safety check

                const { mediaType } = meta;
                const isDuplicate = media.tag?.duplicatePlacements?.length > 0;

                (media?.adlabels || []).forEach(label => {
                    const placement = label.name;
                    if (!placement) return;

                    asset_customization_rules?.push({
                        [mediaType === 'image' ? 'image_label' : 'video_label']: { name: placement },
                        customization_spec: isDuplicate
                            ? {}
                            : (mediaType === 'image' ? imagePlacementConfig : videoPlacementConfig)[placement] || {}
                    });
                });
            });

            const titles = values.creative?.object_story_spec?.link_data?.name
                ? [{ text: values.creative.object_story_spec.link_data.name }]
                : undefined;

            const bodies = values.creative?.object_story_spec?.link_data?.message
                ? [{ text: values.creative.object_story_spec.link_data.message }]
                : undefined;

            const descriptions =  values.creative.object_story_spec.link_data.description
                ? [{ text: values.creative.object_story_spec.link_data.description }]
                : undefined;
               
            const call_to_action_types = [values.creative.object_story_spec.link_data.call_to_action.type];

            const call_to_actions = [
                ...(selectedAdset?.destination_type === 'PHONE_CALL' ? [{
                  type: values.creative.object_story_spec.link_data.call_to_action.type,
                  value: {
                    link: formatPhoneNumber(values.creative.object_story_spec.link_data.call_to_action.value.link)
                  }
                }] : []),
              
                ...(selectedAdset?.destination_type === 'ON_AD' ? [{
                  type: values.creative.object_story_spec.link_data.call_to_action.type,
                  value: {
                    lead_gen_form_id: values.creative.object_story_spec.link_data.call_to_action?.value?.lead_gen_form_id
                  }
                }] : []),

                ...(selectedAdset?.destination_type === 'WHATSAPP' ? [{
                    type: values.creative.object_story_spec.link_data.call_to_action.type,
                    value: {
                      app_destination : "WHATSAPP"
                    }
                }] : [])
              ];

            const websiteUrl = selectedAdset?.destination_type === 'PHONE_CALL'
                                ? `https://facebook.com/${values.creative.object_story_spec.page_id || ''}/`
                                : selectedAdset?.destination_type === 'ON_AD'
                                ? 'http://fb.me/'
                                : selectedAdset?.destination_type === 'APP'
                                    ? selectedAdset?.promoted_object?.object_store_url
                                    : selectedAdset?.destination_type === 'WHATSAPP'
                                    ? "https://api.whatsapp.com/send"
                                    : values.creative.object_story_spec.link_data.link || '';

            const link_urls = [
                {
                    website_url: websiteUrl,
                    ...(selectedAdset?.destination_type === 'APP' && { deeplink_url: values.creative.object_story_spec.link_data.link }),
                    ...(!['CALL_NOW','LIKE_PAGE'].includes(values.creative.object_story_spec.link_data.call_to_action.type) && {display_url: values.creative.object_story_spec.link_data.caption})
                }
            ];

            const app_product_page_id = values.creative.app_product_page_id;
            const creative_features_spec = {
                ...((values.creative.object_story_spec.link_data.call_to_action.type !== 'LIKE_PAGE' &&
                   !['WEBSITE_AND_PHONE_CALL', 'WEBSITE_AND_LEAD_FORM'].includes(selectedAdset?.destination_type)) && {
                  pac_relaxation: { 
                    enroll_status: values?.pac_relaxation_enroll_status,
                  }
                })
              };
              
            const degrees_of_freedom_spec = Object.keys(creative_features_spec).length > 0
                ? { creative_features_spec }
                : undefined;
              


            let adcreativePayload = {};

            if (allUrlsMatch) {
                adcreativePayload = values?.adType === 'video' ? {
                    adcreative: {
                        object_type: "VIDEO",
                        hash: values.hash,
                        ...(values.creative.url_tags?.trim() && { url_tags: values.creative.url_tags }),
                        object_story_spec: {
                            video_data: {
                                image_url: values?.image_url,
                                ...(values.creative.object_story_spec.link_data.message?.trim() && {
                                    message: values.creative.object_story_spec.link_data.message
                                }),
                                video_id: values.creative.object_story_spec.link_data.image_hash,
                                title: values.creative.object_story_spec.link_data.name,
                                link_description: values.creative.object_story_spec.link_data.description,
                                call_to_action: {
                                    type: values.creative.object_story_spec.link_data.call_to_action.type,
                                    value: selectedAdset?.destination_type === 'ON_AD'
                                        ? {
                                            lead_gen_form_id: values.creative.object_story_spec.link_data.call_to_action?.value?.lead_gen_form_id,
                                            link_caption: values.creative.object_story_spec.link_data.caption,
                                        }
                                        : selectedAdset?.destination_type === 'WEBSITE_AND_LEAD_FORM'
                                        ? {
                                            lead_gen_form_id: values.creative.object_story_spec.link_data.call_to_action?.value?.lead_gen_form_id,
                                            link_caption: values.creative.object_story_spec.link_data.caption,
                                            link: values.creative.object_story_spec.link_data.link,
                                        }
                                        : selectedAdset?.destination_type === 'WHATSAPP'
                                        ? {
                                            app_destination: "WHATSAPP",
                                            link: "https://api.whatsapp.com/send"
                                        }
                                        : selectedAdset?.destination_type === 'APP' ?
                                            {
                                                app_link: values.creative.object_story_spec.link_data.link,
                                                link: selectedAdset?.promoted_object?.object_store_url,
                                            } :
                                            {
                                                link: values.creative.object_story_spec.link_data.call_to_action.type === "CALL_NOW"
                                                    ? formatPhoneNumber(values.creative.object_story_spec.link_data.call_to_action.value.link)
                                                    : values.creative.object_story_spec.link_data.link,
                                                link_caption: values.creative.object_story_spec.link_data.caption,
                                            }
                                },
                                ...((['WHATSAPP'].includes(selectedAdset?.destination_type)) && { page_welcome_message: values?.page_welcome_message }),
                            },
                            ...storySpec,
                        },
                        contextual_multi_ads,
                        ...(selectedAdset?.destination_type === 'WEBSITE_AND_PHONE_CALL' && {
                                asset_feed_spec : {
                                    call_ads_configuration: {
                                        call_destination_type : "WEBSITE_AND_CALL",
                                        phone_number: formatPhoneNumber(values.creative.object_story_spec.link_data.call_to_action.value.link)
                                    }
                                }
                        }),
                        ...(selectedAdset?.destination_type === 'APP' && {
                            asset_feed_spec: {
                                app_product_page_id: values.creative.app_product_page_id,
                            }
                        }),
                        degrees_of_freedom_spec,
                    },
                    } : {
                        adcreative: {
                            object_type: "SHARE",
                            hash: values.hash,
                            image_url: values?.image_url,
                            ...(values.creative?.url_tags?.trim() && { url_tags: values.creative.url_tags }),
                            object_story_spec: {
                                link_data: {
                                    ...(values.creative.object_story_spec.link_data.message?.trim() && {
                                        message: values.creative.object_story_spec.link_data.message
                                    }),
                                    name: values.creative.object_story_spec.link_data.name,
                                    description: values.creative.object_story_spec.link_data.description,
                                    image_hash: values.creative.object_story_spec.link_data.image_hash,
                                    caption: values.creative.object_story_spec.link_data.caption,
                                    link: selectedAdset?.destination_type === 'ON_AD'
                                        ? "http://fb.me/"
                                        : selectedAdset?.destination_type === 'WHATSAPP'
                                        ? "https://api.whatsapp.com/send"
                                        : selectedAdset?.destination_type === 'APP'
                                            ? selectedAdset?.promoted_object?.object_store_url
                                            : values.creative.object_story_spec.link_data.link
                                                ? values.creative.object_story_spec.link_data.link
                                                : `https://facebook.com/${values.creative.object_story_spec.page_id}/`,
                                    call_to_action: {
                                        type: values.creative.object_story_spec.link_data.call_to_action.type,
                                        value: ['ON_AD', 'WEBSITE_AND_LEAD_FORM'].includes(selectedAdset?.destination_type)
                                            ? {
                                                lead_gen_form_id: values.creative.object_story_spec.link_data.call_to_action?.value?.lead_gen_form_id
                                            }
                                            : values.creative.object_story_spec.link_data.call_to_action.type === 'CALL_NOW'
                                                ? {
                                                    link: values.creative.object_story_spec.link_data.call_to_action?.value?.link
                                                        ? formatPhoneNumber(values.creative.object_story_spec.link_data.call_to_action.value.link)
                                                        : undefined
                                                }
                                                : selectedAdset?.destination_type === 'APP'
                                                    ? {
                                                        app_link: values.creative.object_story_spec.link_data.link
                                                    }
                                                        : selectedAdset?.destination_type === 'WHATSAPP'
                                                        ? {
                                                            app_destination: "WHATSAPP"
                                                        }
                                                        : undefined
                                    },
                                    ...((['WHATSAPP'].includes(selectedAdset?.destination_type)) && { page_welcome_message: values?.page_welcome_message }),
                                },
                                ...storySpec,
                            },
                            contextual_multi_ads,
                            ...(selectedAdset?.destination_type === 'WEBSITE_AND_PHONE_CALL' && {
                                asset_feed_spec : {
                                    call_ads_configuration: {
                                        call_destination_type : "WEBSITE_AND_CALL",
                                        phone_number: formatPhoneNumber(values.creative.object_story_spec.link_data.call_to_action.value.link)
                                    }
                                }
                            }),
                            ...(selectedAdset?.destination_type === 'APP' && {
                                asset_feed_spec: {
                                    app_product_page_id: values.creative.app_product_page_id,
                                }
                            }),
                            degrees_of_freedom_spec,
                        },
                    };
            } else {
                adcreativePayload = values?.adType === 'video' ?
                    {
                        adcreative: {
                            object_type: "VIDEO",
                            object_story_spec: storySpec,
                            contextual_multi_ads,
                            ...(values.creative?.url_tags?.trim() && { url_tags: values.creative.url_tags }),
                            asset_feed_spec: {
                                ad_formats: [
                                    "SINGLE_VIDEO"
                                ],
                                videos: cleanedMediaData,
                                asset_customization_rules: asset_customization_rules,
                                call_to_action_types,
                                call_to_actions,
                                link_urls,
                                app_product_page_id,
                                optimization_type: "PLACEMENT",
                                ...(titles && { titles }),
                                ...(bodies && { bodies }),
                                ...(descriptions && { descriptions }),
                                ...((['WHATSAPP'].includes(selectedAdset?.destination_type)) && {
                                    additional_data:{
                                        page_welcome_message: values?.page_welcome_message 
                                    }
                                }),
                            },
                            degrees_of_freedom_spec,
                        }
                    } : {
                        adcreative: {
                            object_type: "SHARE",
                            object_story_spec: storySpec,
                            contextual_multi_ads,
                            ...(values.creative?.url_tags?.trim() && { url_tags: values.creative.url_tags }),
                            asset_feed_spec: {
                                ad_formats: [
                                    "SINGLE_IMAGE"
                                ],
                                images: cleanedMediaData,
                                asset_customization_rules: asset_customization_rules,
                                call_to_action_types,
                                call_to_actions,
                                link_urls,
                                app_product_page_id,
                                optimization_type: "PLACEMENT",
                                ...(titles && { titles }),
                                ...(bodies && { bodies }),
                                ...(descriptions && { descriptions }),
                                ...((['WHATSAPP'].includes(selectedAdset?.destination_type)) && {
                                    additional_data:{
                                        page_welcome_message: values?.page_welcome_message 
                                    }
                                }),
                            },
                            degrees_of_freedom_spec,
                        }
                    }
            }

            const initialPayload = {
                ...adcreativePayload,
                name: values.name,
                cpa: Number(values.cpa),
                ...(!allUrlsMatch && { objective: objective }),
                adset_id: selectedAdset?.adset_id,
                destination_type: selectedAdset?.destination_type,
                currency: adsAccountData?.currency,
                adsAccount: {
                    id: adsAccountData?.id,
                    adsAccountId: adsAccountData?.account_id,
                    adsAccountName: adsAccountData?.name,
                    businessName: adsAccountData?.business?.name,
                    businessId: adsAccountData?.business?.id,
                },
            };

            const payload = removeEmptyValues(initialPayload);

            createAd({ payload })
                .unwrap()
                .then(response => {
                    onSuccess();
                    toast({
                        position: "top-right",
                        title: "Ad Created",
                        status: "success",
                        duration: 4000,
                        isClosable: true,
                    });
                })
                .catch(error => {
                    toast({
                        position: "top-right",
                        title: "Error creating Ad",
                        description: error?.data?.message,
                        status: "error",
                        duration: 4000,
                        isClosable: true,
                    });
                })
                .finally(() => {
                    setSubmitting(false);
                    onClose();
                });
        },
    });

    useEffect(() => {
        if (adFormik.values !== prevAdFormikValues) {
            setPrevAdFormikValues(adFormik.values);
    
            formik.setValues((prevValues) => ({
                ...prevValues,
                name: adFormik.values?.name,
                enroll_status: adFormik.values?.enroll_status,
                creative: {
                    ...prevValues.creative,
                    object_story_spec: {
                        ...prevValues.creative?.object_story_spec,
                        page_id: adFormik.values?.page_id,
                        instagram_user_id: adFormik.values?.instagram_user_id,
                    },
                },
            }));
        }
    }, [adFormik.values]);
      

    useEffect(() => {
        onFormValuesChange(formik.values);
    }, [formik.values, onFormValuesChange]);

    useEffect(() => {
        if (formik?.values?.image_url) {
            formik.setFieldTouched('image_url', true);
        }
    }, [formik.values])

    useEffect(() => {
        if(selectedMediaUrls){
            const allUrlsMatch = selectedMediaUrls?.every(
                (item) => item.hash === selectedMediaUrls[0]?.hash
            );
            if(!allUrlsMatch){
                formik.setFieldValue('mediaUrls', selectedMediaUrls);
            }
        }
    },[selectedMediaUrls])

    const handleMediaTypeChange = (type) => {
        setMediaType(type)
        setHasSelectedFiles(false);
        onCreativeModalOpen();
        formik.setFieldValue('adType', type)
    };

    const handleMediaSelect = (file) => {
        if (file && file.length > 0) {
            const selectedFile = file[0];

            if (selectedAdset?.destination_type !== 'ON_PAGE') {
                const placements = ['square', 'vertical', 'horizontal'];

                const fileData = placements.map((placement) => ({
                    placement,
                    url: selectedFile?.url ? selectedFile?.url : selectedFile?.picture,
                    source: selectedFile?.source,
                    mediaType: selectedFile?.url ? 'image' : 'video',
                    hash: selectedFile?.creativeId,
                    mediaHash: selectedFile?.hash,
                }));

                setselectedMediaUrls(fileData);
            }
            formik.setFieldValue('hash', selectedFile?.hash);
            formik.setFieldValue('image_url', selectedFile?.url ? selectedFile?.url : selectedFile?.picture);
            formik.setFieldValue('creative.object_story_spec.link_data.image_hash', selectedFile?.creativeId);
        }
    };

    const handleReplaceImage = (placement, type) => {
        setActivePlacement(placement);
        OnReplaceModalOpen();
        setMediaType(type);
        formik.setFieldValue('adType', type);
    };

    const handleImageSelectedFromReplaceDrive = (file) => {
        if (file && file.length > 0) {

            const newImageUrl = file[0];

            setselectedMediaUrls((prev) =>
                prev.map((item) =>
                    item.placement === activePlacement
                        ? {
                            ...item,
                            url: newImageUrl?.url ? newImageUrl?.url : newImageUrl?.picture,
                            hash: newImageUrl?.creativeId,
                            mediaHash: newImageUrl?.hash,
                            source: newImageUrl?.source,
                        }
                        : item
                )
            );

            formik.setFieldValue('creative.object_story_spec.link_data.image_hash', newImageUrl?.creativeId);
            formik.setFieldValue('image_url', newImageUrl?.url ? newImageUrl?.url : newImageUrl?.picture,);
        }

        setActivePlacement(null);
        OnReplaceModalClose();
    };

    const handleUrlChange = (constructedUrl) => {
        formik.setFieldValue('creative.object_story_spec.link_data.link', constructedUrl);
    };

    const handleUrlParamChange = (constructedUrl) => {
        formik.setFieldValue('creative.url_tags', constructedUrl);
    };

    const handleAiUploadedMedia = (data) => {
        const mappedMediaFiles = data.map(item => {
            const dynamicKeyData = item[item?.name] || {};

            return {
                creativeType: item?.creativeType,
                creativeId: item?.creativeId,
                source: item?.source,
                url: dynamicKeyData?.url || "",
                picture: dynamicKeyData?.url || "",
                hash: item?.hash,
                name: item?.name,
                adsAccount: {
                    adsAccountId: item?.adsAccount?.adsAccountId
                }
            };
        });

        if (mappedMediaFiles.length > 0) {
            const selectedFile = mappedMediaFiles[0];

            formik.setFieldValue('hash', selectedFile?.hash);
            formik.setFieldValue('image_url', selectedFile?.url ? selectedFile?.url : selectedFile?.picture);
            formik.setFieldValue(
                'creative.object_story_spec.link_data.image_hash',
                selectedFile?.creativeId
            );

            if (selectedAdset?.destination_type !== 'ON_PAGE') {
                const placements = ['square', 'vertical', 'horizontal'];

                const fileData = placements.map((placement) => ({
                    placement,
                    url: selectedFile?.url ? selectedFile?.url : selectedFile?.picture,
                    source: selectedFile?.source,
                    mediaType: selectedFile?.url ? 'image' : 'video',
                    hash: selectedFile?.creativeId,
                    mediaHash: selectedFile?.hash,
                }));

                setselectedMediaUrls(fileData);
            }
        }

    };

    const filteredInstantForms = instantForms?.length > 0 && instantForms
        .map((formResponse) => formResponse?.data?.data) // Get the 'data' array from each formResponse
        .flat() // Flatten the array to get all forms in one array
        .filter((form) => form?.page_id === pageId);
        
    return (
        <Box direction={'column'} gap={4} width={'100%'}>
            <form onSubmit={formik.handleSubmit}>
                <Flex direction={'column'} gap={'10px'} borderRadius="md" bg={background} p={4} mb={4}>
                    <Flex justifyContent={'space-between'}>
                        <Flex direction="column">
                            <Select
                                placeholder={adFormik?.values?.format === 'CAROUSEL' ? "Add cards" : "Add media"}
                                width={'150px'}
                                name="mediaOption"
                                borderRadius={'md'}
                                value={mediaType || ""}
                                onChange={(e) => {
                                    handleMediaTypeChange(e.target.value);
                                }}
                                size="sm"
                            >
                                <option value="image">{adFormik?.values?.format === 'CAROUSEL' ? "Add image cards" : "Add image"}</option>
                                <option value="video">{adFormik?.values?.format === 'CAROUSEL' ? "Add video cards" : "Add video"}</option>
                            </Select>
                        </Flex>

                        <Flex alignItems={'center'} gap={2}>
                            <Menu>
                                <MenuButton
                                    as={Button}
                                    colorScheme='brand'
                                    size='sm'
                                    _expanded={{ bg: 'orange.600' }}
                                    rightIcon={<ChevronDownIcon boxSize={5} />}
                                >
                                    <Flex align="center">
                                        <Icon as={BsStars} boxSize={4} mr={2} />
                                        AI Generation
                                    </Flex>
                                </MenuButton>
                                <MenuList sx={{ minWidth: "180px" }}>
                                    <MenuItem onClick={onAiImageModalOpen} fontSize='14px'>
                                        Generate Image
                                    </MenuItem>
                                    <MenuItem onClick={onAiVideoModalOpen} fontSize='14px'>
                                        Generate Video
                                    </MenuItem>
                                </MenuList>
                            </Menu>

                            <Tooltip
                                borderRadius={5}
                                label={
                                    <Flex direction={'column'} gap={4} fontSize="12px" p="5px">
                                        <Flex direction={'column'} gap={2}>
                                            <Text fontWeight={'bold'}>AI Image Generation</Text>
                                            <Text>AI-generated image variations are inspired by your original asset.</Text>
                                            <Flex direction={'column'} gap={2}>
                                                <Text fontWeight={'bold'}>Types of AI Variations:</Text>
                                                <Text>Background Variation: Your product is placed in different, relevant environments.</Text>
                                                <Text>Creative Variation: Entirely new visuals generated based on your original creative.</Text>
                                            </Flex>
                                        </Flex>
                                        <Flex direction={'column'} gap={2}>
                                            <Text fontWeight={'bold'}>AI Video Generation</Text>
                                            <Text>AI-generated video ads are created using your product information, images, or scripts.</Text>
                                            <Flex direction={'column'} gap={2}>
                                                <Text fontWeight={'bold'}>Types of AI Variations:</Text>
                                                <Text>Product URL Based: Generates video using product details pulled from your URL.</Text>
                                                <Text>Asset Based: Combines your visual assets into fully edited video ads.</Text>
                                            </Flex>
                                        </Flex>
                                        <Text>Note: Hustle does not guarantee the completeness, accuracy, or reliability of AI-generated assets.</Text>
                                    </Flex>
                                }
                                fontSize="md"
                            >
                                <InfoOutlineIcon pointerEvents="all" />
                            </Tooltip>
                        </Flex>
                    </Flex>

                    {formik.touched.image_url && formik.errors.image_url && (
                        <Text fontSize={"12px"} color="red.500">{formik.errors.image_url}</Text>
                    )}

                    <Divider my={1} />

                    {selectedAdset?.destination_type !== 'ON_PAGE' ?
                        <>
                            {selectedMediaUrls && selectedMediaUrls[0]?.url && (
                                <Flex gap={4}>
                                    <Image
                                        src={(selectedMediaUrls[0]?.url)}
                                        alt={"adcreative-img"}
                                        objectFit="cover"
                                        width="80px"
                                        height="80px"
                                        borderRadius="3px"
                                    />

                                    <Flex align={'center'} justify={'space-between'} gap={2}>
                                        
                                            {["WEBSITE_AND_PHONE_CALL","WEBSITE_AND_LEAD_FORM"].includes(selectedAdset?.destination_type ) ?
                                                <Flex>
                                                 <Button
                                                     bg={buttonBackgroundColor}
                                                     size="xs"
                                                     borderWidth={1}
                                                     onClick={() => handleMediaTypeChange(formik?.values?.adType)}>
                                                     {formik?.values?.adType === 'image' ? "Change Image" : "Change Video"}
                                                 </Button>
                                             </Flex>
                                            : 
                                            <>
                                                <Tooltip label="Edit Media" fontSize="xs">
                                                    <Flex
                                                        p={2}
                                                            border="1px solid"
                                                            borderColor={boxBorder}
                                                            borderRadius="md"
                                                            alignItems={'center'}
                                                            _hover={{ bg: 'gray.100' }}
                                                        >
                                                            <Icon
                                                                as={MdOutlineEdit}
                                                                cursor="pointer"
                                                                fontSize="18px"
                                                                onClick={OnEditMediaOpen}
                                                            />
                                                    </Flex>
                                                </Tooltip>
                                                <Tooltip label="Remove Media" fontSize="xs">
                                                <Flex
                                                    p={2}
                                                    border="1px solid"
                                                    borderColor={boxBorder}
                                                    borderRadius="md"
                                                    alignItems={'center'}
                                                    _hover={{ bg: 'gray.100' }}
                                                >
                                                    <Icon
                                                        as={MdDeleteOutline}
                                                        cursor="pointer"
                                                        fontSize={'18px'}
                                                        onClick={() => {
                                                            formik.setFieldValue('image_url', '');
                                                            formik.setFieldValue('mediaUrls', []);
                                                            setselectedMediaUrls([]);
                                                        }}
                                                    />
                                                </Flex>
                                                </Tooltip>
                                            </>
                                            }
                                    </Flex>
                                </Flex>
                            )}
                        </>
                        :
                        <>
                            {formik.values.image_url && (
                                <Flex gap={4}>
                                    <Image
                                        src={formik.values.image_url}
                                        alt={formik.values.name}
                                        objectFit="cover"
                                        width="80px"
                                        height="80px"
                                        borderRadius="3px"
                                    />

                                    <Flex align={'center'} justify={'space-between'} gap={2}>
                                        <Tooltip label="Remove Media" fontSize="xs">
                                            <Flex
                                                p={2}
                                                border="1px solid"
                                                borderColor={boxBorder}
                                                borderRadius="md"
                                                alignItems={'center'}
                                                _hover={{ bg: 'gray.100' }}
                                            >
                                                <Icon
                                                    as={MdDeleteOutline}
                                                    cursor="pointer"
                                                    fontSize={'18px'}
                                                    onClick={() =>
                                                        formik.setFieldValue('image_url', '')
                                                    }
                                                />
                                            </Flex>
                                        </Tooltip>
                                    </Flex>
                                </Flex>
                            )}
                        </>
                    }

                    {!["WEBSITE_AND_PHONE_CALL", "WEBSITE_AND_LEAD_FORM"].includes(selectedAdset?.destination_type ) ? 
                        <Flex direction={'column'} gap={2} mb={2}>
                            <Flex alignItems="center">
                                <Text fontWeight="bold" mr={2}>Flexible media</Text>
                                <Tooltip
                                    borderRadius={5}
                                    label={
                                        <Flex direction={'column'} fontSize="12px" p="5px" gap={2}>
                                            <Text fontWeight={'bold'}>Flexible media</Text>
                                            <Text>Show media that you chose for a specific aspect ratio across all placements when it's likely to improve performance. You can turn off flexible media at any time in ad creative.</Text>
                                            <Text>To preview flexible media, select a specific placement group at the top of Ad preview.</Text>
                                        </Flex>
                                    }
                                    fontSize="md"
                                >
                                    <InfoOutlineIcon pointerEvents="all" />
                                </Tooltip>
                            </Flex>
                            <Flex alignItems={'center'} gap={2}>
                                <Switch colorScheme='brand' size={'sm'} isChecked={formik.values.pac_relaxation_enroll_status === 'OPT_IN'} onChange={(e) => formik.setFieldValue('pac_relaxation_enroll_status', e.target.checked ? 'OPT_IN' : 'OPT_OUT')} />
                                <Text fontSize="12px">We'll deliver your media selections across your placements when it's likely to improve performance.</Text>
                            </Flex>
                        </Flex>
                    :null}


                    <Flex direction="column" gap={1}>
                        <Flex alignItems="center">
                            <Text fontWeight="bold" fontSize="14px" mr={2}>Primary text</Text>
                            {/* <Text display="inline-flex" fontSize="18px" color="red.400" mr={2}>*</Text> */}
                            <Tooltip
                                borderRadius={5}
                                label={
                                    <Box fontSize="14px" p="5px">
                                        <Text>
                                            The primary text for your ad appears in most placements, though the position
                                            varies. You can use @ to tag Facebook profiles or Pages. We recommend 125
                                            characters or less.
                                        </Text>
                                    </Box>
                                }
                                fontSize="md"
                            >
                                <InfoOutlineIcon pointerEvents="all" />
                            </Tooltip>
                        </Flex>
                        <Textarea
                            name="creative.object_story_spec.link_data.message"
                            placeholder="Message"
                            bg="#fff"
                            size='sm'
                            borderRadius="md"
                            value={formik.values.creative.object_story_spec.link_data.message}
                            onChange={formik.handleChange}
                        />
                        {formik.touched.creative?.object_story_spec?.link_data?.message && formik.errors.creative?.object_story_spec?.link_data?.message && (
                            <Text fontSize={"12px"} color="red.500">{formik.errors.creative?.object_story_spec?.link_data?.message}</Text>
                        )}
                    </Flex>

                    <Flex direction="column" gap={1}>
                        <Flex alignItems="center" gap={2}>
                            <Text fontWeight="bold" fontSize={'14px'}>Headline</Text>
                            <Tooltip
                                borderRadius={5}
                                label={
                                    <Box fontSize="sm" p="5px">
                                        <Text>
                                            Add up to five brief headlines to let people know what your ad is about. Each
                                            headline can have a maximum of 255 characters. Headlines won't appear in all
                                            placements.
                                        </Text>
                                    </Box>
                                }
                                fontSize="md">
                                <InfoOutlineIcon pointerEvents="all" />
                            </Tooltip>
                        </Flex>
                        <Input
                            name="creative.object_story_spec.link_data.name"
                            placeholder="Write a short headline"
                            bg="#fff"
                            size='sm'
                            borderRadius="md"
                            value={formik.values.creative.object_story_spec.link_data.name}
                            onChange={formik.handleChange}
                        />
                        {formik.touched.creative?.object_story_spec?.link_data?.name && formik.errors.creative?.object_story_spec?.link_data?.name && (
                            <Text fontSize={"12px"} color="red.500">{formik.errors.creative?.object_story_spec?.link_data?.name}</Text>
                        )}
                    </Flex>

                    {selectedAdset?.destination_type === 'APP' ? null :
                        <Flex direction="column" gap={1}>
                            <Flex alignItems="center" gap={2}>
                                <Text fontWeight="bold" fontSize={'14px'}>Description</Text>
                                <Tooltip
                                    borderRadius={5}
                                    label={
                                        <Box fontSize="sm" p="5px">
                                            <Text>
                                                Add up to five link descriptions to emphasise why people should visit your
                                                website. This won't appear in all placements.
                                            </Text>
                                        </Box>
                                    }
                                    fontSize="md">
                                    <InfoOutlineIcon pointerEvents="all" />
                                </Tooltip>
                            </Flex>
                            <Textarea
                                name="creative.object_story_spec.link_data.description"
                                placeholder="Include additional details"
                                bg="#fff"
                                size='sm'
                                borderRadius="md"
                                value={formik.values.creative.object_story_spec.link_data.description}
                                onChange={formik.handleChange}
                            />
                            {formik.touched.creative?.object_story_spec?.link_data?.description && formik.errors.creative?.object_story_spec?.link_data?.description && (
                                <Text fontSize={"12px"} color="red.500">{formik.errors.creative?.object_story_spec?.link_data?.description}</Text>
                            )}
                        </Flex>
                    }

                    <Flex direction="column" gap={1}>
                        <Flex alignItems="center" mb={2} gap={2}>
                            <Text fontWeight="bold" fontSize="14px">Call to action</Text>
                            <Tooltip
                                borderRadius={5}
                                label={
                                    <Box fontSize="sm" p="5px">
                                        <Text>Show a button or link on your ad that represents the action you want people to take.</Text>
                                    </Box>
                                }
                                fontSize="md"
                            >
                                <InfoOutlineIcon pointerEvents="all" />
                            </Tooltip>
                        </Flex>

                        {selectedAdset?.destination_type === 'PHONE_CALL' ? (
                            <Select
                                name="creative.object_story_spec.link_data.call_to_action.type"
                                bg="#fff"
                                size="sm"
                                borderRadius="md"
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.creative.object_story_spec.link_data.call_to_action.type}
                                isDisabled
                            >
                                <option value="CALL_NOW">Call Now</option>
                            </Select>
                        ) : ['ON_AD', 'WEBSITE_AND_LEAD_FORM'].includes(selectedAdset?.destination_type) && objective === 'OUTCOME_LEADS' ? (
                            <Box direction="column" mb={'10px'}>

                                <Select
                                    name="creative.object_story_spec.link_data.call_to_action.type"
                                    bg="#fff"
                                    size="sm"
                                    borderRadius="md"
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.creative.object_story_spec.link_data.call_to_action.type}
                                >
                                    {call_to_action_options_instantForms?.map((option) => (
                                        <option key={option.value} value={option.value}>
                                            {option.label}
                                        </option>
                                    ))}
                                </Select>
                            </Box>
                        ) : selectedAdset?.destination_type === 'APP' && objective === 'OUTCOME_APP_PROMOTION'  ? (
                            <Select
                                name="creative.object_story_spec.link_data.call_to_action.type"
                                bg="#fff"
                                size="sm"
                                borderRadius="md"
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.creative.object_story_spec.link_data.call_to_action.type}
                            >
                                {call_to_action_options_app_promptions.map(option => (
                                    <option key={option.value} value={option.value}>
                                        {option.label}
                                    </option>
                                ))}
                            </Select>
                        ) : selectedAdset?.destination_type === 'APP' && ["OUTCOME_SALES", "OUTCOME_LEADS"].includes(objective) ? (
                            <Select
                                name="creative.object_story_spec.link_data.call_to_action.type"
                                bg="#fff"
                                size="sm"
                                borderRadius="md"
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.creative.object_story_spec.link_data.call_to_action.type}
                            >
                                {call_to_action_options_for_app_leads_and_sales.map(option => (
                                    <option key={option.value} value={option.value}>
                                        {option.label}
                                    </option>
                                ))}
                            </Select>
                        ) : selectedAdset?.destination_type === 'WHATSAPP' ? (
                            <Select
                                name="creative.object_story_spec.link_data.call_to_action.type"
                                bg="#fff"
                                size="sm"
                                borderRadius="md"
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.creative.object_story_spec.link_data.call_to_action.type}
                                isDisabled={objective === 'OUTCOME_LEADS'}
                            >
                                {call_to_action_options_whatsapp.map(option => (
                                    <option key={option.value} value={option.value}>
                                        {option.label}
                                    </option>
                                ))}
                            </Select>
                        ) : (
                            <Select
                                name="creative.object_story_spec.link_data.call_to_action.type"
                                bg="#fff"
                                size="sm"
                                borderRadius="md"
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.creative.object_story_spec.link_data.call_to_action.type}
                            >
                                {call_to_action_options.map(option => (
                                    <option key={option.value} value={option.value}>
                                        {option.label}
                                    </option>
                                ))}
                            </Select>
                        )}

                        {formik.touched.creative?.object_story_spec?.link_data?.call_to_action?.type &&
                            formik.errors.creative?.object_story_spec?.link_data?.call_to_action?.type && (
                                <Text fontSize="12px" color="red.500">
                                    {formik.errors.creative.object_story_spec.link_data.call_to_action.type}
                                </Text>
                            )}
                    </Flex>

                    {['WEBSITE', 'WEBSITE_AND_PHONE_CALL', 'WEBSITE_AND_LEAD_FORM'].includes(selectedAdset?.destination_type) ? (
                        <Flex direction="column" gap={1}>
                            <Flex alignItems="center">
                                <Text fontWeight="bold" fontSize={'14px'}>Website URL</Text>
                                <Text display="inline-flex" fontSize="18px" color="red.400" mr={2}>*</Text>
                                <Tooltip
                                    borderRadius={5}
                                    label={
                                        <Box fontSize="sm" p="5px">
                                            <Text>Enter the URL for the webpage you want people to visit</Text>
                                        </Box>
                                    }
                                    fontSize="md"
                                >
                                    <InfoOutlineIcon pointerEvents="all" />
                                </Tooltip>
                            </Flex>
                            <Box position="relative">
                                <Flex justifyContent={'space-between'} gap={4}>
                                    <Input
                                        type="url"
                                        name="creative.object_story_spec.link_data.link"
                                        bg="#fff"
                                        borderRadius="md"
                                        placeholder="Enter a URL"
                                        autoComplete="off"
                                        value={formik.values.creative.object_story_spec.link_data.link}
                                        onChange={formik.handleChange}
                                        onFocus={() => {
                                            if (Array.isArray(landersData?.deployedProjects) && landersData.deployedProjects.length) {
                                            setShowSavedLanders(true);
                                            }
                                        }}
                                        onBlur={() => {
                                            // Delay so onMouseDown in the menu can run first
                                            setTimeout(() => setShowSavedLanders(false), 120);
                                        }}
                                        size="sm"
                                    />
                                    <Button
                                        px={5}
                                        as={Link}
                                        href={`${process.env.REACT_APP_CANVA_BASE_URL}/authenticateHustle?token=${userInfo?.token}`}
                                        colorScheme="blue"
                                        size="sm"
                                        isExternal
                                        leftIcon={<Icon as={IoBuildOutline} />}
                                    >
                                        Build More
                                    </Button>
                                </Flex>

                                {/* Saved lander projects dropdown */}
                                {Array.isArray(landersData?.deployedProjects) &&
                                  landersData.deployedProjects.length > 0 &&
                                  showSavedLanders && (
                                    <Box
                                      position="absolute"
                                      mt={1}
                                      borderWidth="1px"
                                      borderRadius="md"
                                      bg="white"
                                      boxShadow="md"
                                      maxH="180px"
                                      overflowY="auto"
                                      zIndex={20}
                                      width="100%"
                                    >
                                      {landersData.deployedProjects.map((project) => {
                                        const depUrl = project.deploymentUrl || "";
                                        const isSelected = formik.values.creative.object_story_spec.link_data.link === depUrl;
                                        return (
                                          <Box
                                            key={project.uiId}
                                            as="button"
                                            type="button"
                                            width="100%"
                                            px={2}
                                            py={2}
                                            textAlign="left"
                                            bg={isSelected ? "brand.50" : ListBgColor}
                                            _hover={{ bg: hoverBorder }}
                                            onMouseDown={(e) => {
                                                e.preventDefault();
                                                formik.setFieldValue(
                                                  "creative.object_story_spec.link_data.link",
                                                  depUrl
                                                );
                                                setShowSavedLanders(false);
                                              }}
                                          >
                                            <Text fontSize="12px" noOfLines={1}>
                                              {project.deploymentUrl}
                                            </Text>
                                          </Box>
                                        );
                                      })}
                                    </Box>
                                  )}
                            </Box>
                            <Flex mt={2}>
                                <Button onClick={() => {
                                    setUrlModalOpen(true)
                                }}
                                    variant="link"
                                    color='brand'>
                                    <Text fontSize={'12px'} >{'Build a URL parameter'}</Text>
                                </Button>
                            </Flex>
                            {formik.touched.creative?.object_story_spec?.link_data?.link && formik.errors.creative?.object_story_spec?.link_data?.link && (
                                <Text fontSize={"12px"} color="red.500">{formik.errors.creative?.object_story_spec?.link_data?.link}</Text>
                            )}
                        </Flex>
                    ) : null}

                    {['PHONE_CALL', 'WEBSITE_AND_PHONE_CALL'].includes(selectedAdset?.destination_type) ? (
                        <Flex direction="column" gap={1}>
                            <Flex alignItems="center" mb={2}>
                                <Text fontWeight="bold" fontSize={'14px'}>Call now</Text>
                                <Text display="inline-flex" fontSize="18px" color="red.400" mr={2}>*</Text>
                                <Tooltip
                                    borderRadius={5}
                                    label={
                                        <Box fontSize="sm" p="5px">
                                            <Text>You can use a different phone number for each carousel card. This can be helpful if you have different phone numbers or extensions.</Text>
                                        </Box>
                                    }
                                    fontSize="md"
                                >
                                    <InfoOutlineIcon pointerEvents="all" />
                                </Tooltip>
                            </Flex>

                            {/* wrapper so the dropdown can position absolutely under the input */}
                            <Box position="relative">
                                <Flex justifyContent={'space-between'}>
                                    <PhoneInput
                                        name="creative.object_story_spec.link_data.call_to_action.value.link"
                                        value={formik.values.creative?.object_story_spec?.link_data?.call_to_action?.value?.link}
                                        onChange={(value) =>
                                        formik.setFieldValue(
                                            'creative.object_story_spec.link_data.call_to_action.value.link',
                                            value
                                        )
                                        }
                                        country="in"
                                        inputProps={{
                                        onFocus: () => setShowSavedPhones(true),
                                        onBlur: () => {
                                            // allow option mousedown to run first
                                            setTimeout(() => setShowSavedPhones(false), 120);
                                        },
                                        }}
                                        inputStyle={{
                                            backgroundColor: bgInput 
                                        }}
                                    />
                                    <Button
                                        px={8}
                                        as={Link}
                                        href={`${process.env.REACT_APP_CONVERSATION_BASE_URL}/authenticateHustle?token=${userInfo?.token}`}
                                        leftIcon={<Icon as={FiPhoneCall} />}
                                        colorScheme="brand"
                                        size="sm"
                                        isExternal
                                        >
                                        AI Call Center
                                    </Button>
                                </Flex>

                                {/* Saved numbers dropdown */}
                                {Array.isArray(callsData?.phoneNumbers) &&
                                    callsData.phoneNumbers.length > 0 &&
                                    showSavedPhones && (
                                    <Box
                                        position="absolute"
                                        px={1}
                                        mt={1}
                                        borderWidth="1px"
                                        borderRadius="md"
                                        bg="white"
                                        boxShadow="md"
                                        maxH="180px"
                                        overflowY="auto"
                                        zIndex={20}
                                    >
                                        {callsData.phoneNumbers.map((pn) => {
                                            const current = formik.values.creative?.object_story_spec?.link_data?.call_to_action?.value?.link || '';
                                            const isSelected = current === pn.number;
                                        return (
                                            <Box
                                            key={pn.id}
                                            as="button"
                                            type="button"
                                            w="100%"
                                            textAlign="left"
                                            px={3}
                                            py={2}
                                            bg={isSelected ? "brand.50" : ListBgColor}
                                            _hover={{ bg: hoverBorder }}
                                            borderBottom="1px solid"
                                            borderColor="gray.100"
                                            onMouseDown={(e) => {
                                                e.preventDefault(); 
                                                const cleanNumber = pn.number?.replace(/^\+/, '');
                                                formik.setFieldValue(
                                                    'creative.object_story_spec.link_data.call_to_action.value.link',
                                                cleanNumber
                                                );
                                                setShowSavedPhones(false);
                                            }}
                                            >
                                                <Text fontWeight="medium" fontSize={'12px'} noOfLines={1}>{pn.number}</Text>
                                            </Box>
                                        );
                                        })}
                                    </Box>
                                    )}
                            </Box>

                           {formik.touched?.creative?.object_story_spec?.link_data?.call_to_action?.value?.link &&
                                formik.errors?.creative?.object_story_spec?.link_data?.call_to_action?.value?.link && (
                                    <Text fontSize="12px" color="red.500">
                                        {formik.errors.creative.object_story_spec.link_data.call_to_action.value.link}
                                    </Text>
                            )}
                        </Flex>
                    ) : null}

                    {['WHATSAPP'].includes(selectedAdset?.destination_type) ? (
                        <>
                            <Flex>
                                <Text fontWeight={'bold'} fontSize={'sm'}>Message template</Text>
                            </Flex>
                        
                            {(() => {
                            const welcomeData = formik?.values?.page_welcome_message;

                            const type = welcomeData?.text_format?.customer_action_type;

                            const greeting = welcomeData?.text_format?.message?.text || '';
                            const autofillMessage = welcomeData?.text_format?.message?.autofill_message?.content || '';
                            const iceBreakers = welcomeData?.text_format?.message?.ice_breakers || [];

                            return (
                                <Box mb={2}>
                                    <Box border={'1px solid'} borderColor={boxBorder} p={2} borderRadius={'md'} bg={backgroundColor}>
                                        <Text fontSize={'14px'}><strong>Greeting:</strong> {greeting}</Text>

                                        {type === 'autofill_message' && (
                                            <Text fontSize={'14px'}><strong>Pre-filled message:</strong> {autofillMessage}</Text>
                                        )}

                                        {type === 'ice_breakers' && (
                                            <>
                                            <Text fontSize={'14px'}><strong>Frequently asked questions</strong></Text>
                                            {iceBreakers.map((q, i) => (
                                                <Text key={i} fontSize="14px">
                                                {i + 1}. {q.title}
                                                </Text>
                                            ))}
                                            </>
                                        )}
                                    </Box>

                                    <Button
                                        variant="outline"
                                        backgroundColor="transparent" 
                                        size={'sm'}
                                        leftIcon={<MdOutlineEdit />}
                                        mt={2}
                                        onClick={() => {
                                            onMessageModalOpen();
                                        }}
                                    >
                                        Edit
                                    </Button>
                                </Box>
                            );
                            })()}
                        </>
                    ) : null}

                    {selectedAdset?.destination_type === 'WEBSITE_AND_LEAD_FORM' && objective === 'OUTCOME_LEADS' ? (
                        <>
                            <Flex alignItems="center">
                                <Text fontWeight="bold" fontSize={'14px'}>Instant form</Text>
                                <Text display="inline-flex" fontSize="18px" color="red.400" mr={2}>*</Text>
                                <Tooltip
                                    borderRadius={5}
                                    label={
                                        <Box fontSize="sm" p="5px">
                                            <Text>Make connections with people by letting them send contact information and other details to you through a form.</Text>
                                        </Box>
                                    }
                                    fontSize="md"
                                >
                                    <InfoOutlineIcon pointerEvents="all" />
                                </Tooltip>
                            </Flex>

                            {/* Table Layout */}
                            {filteredInstantForms?.length > 0 ? (
                                <>
                                    <RadioGroup onChange={(value) => formik.setFieldValue('creative.object_story_spec.link_data.call_to_action.value.lead_gen_form_id', value)} colorScheme="brand" mt={-2}>
                                        <Table variant="simple">
                                            <Thead>
                                                <Tr>
                                                    <Th textTransform={'none'} color={'none'} fontSize="14px" p={-1}>Form title</Th>
                                                    <Th textTransform={'none'} color={'none'} fontSize="14px">Creation date</Th>
                                                </Tr>
                                            </Thead>
                                            <Tbody>
                                                {filteredInstantForms?.map((form) => (
                                                    <Tr key={form?.id}>
                                                        <Td p={-1}>
                                                            <Flex alignItems="center" gap={2}>
                                                                <Radio value={form?.id} />
                                                                <Text color={form.status === 'DRAFT' ? "gray.500" : "none"} fontSize={'12px'}>
                                                                    {form?.name}
                                                                </Text>
                                                            </Flex>
                                                        </Td>
                                                        <Td>
                                                            <Text fontSize={'12px'}>
                                                                {new Date(form?.created_time).getFullYear()}-
                                                                {String(new Date(form?.created_time).getMonth() + 1).padStart(2, '0')}-
                                                                {String(new Date(form?.created_time).getDate()).padStart(2, '0')}
                                                            </Text>
                                                        </Td>
                                                    </Tr>
                                                ))}
                                            </Tbody>
                                        </Table>
                                    </RadioGroup>
                                </>
                            ) : (
                                <Text fontSize="14px" color="gray.500" mb={2}>No form data available</Text>
                            )}
                            {formik.touched?.creative?.object_story_spec?.link_data?.call_to_action?.value?.lead_gen_form_id &&
                                formik.errors?.creative?.object_story_spec?.link_data?.call_to_action?.value?.lead_gen_form_id && (
                                    <Text fontSize="12px" color="red.500">
                                        {formik.errors.creative.object_story_spec.link_data.call_to_action.value.lead_gen_form_id}
                                    </Text>
                            )}
                        </>
                    ) : null}

                    {selectedAdset?.destination_type === 'ON_AD' && objective === 'OUTCOME_LEADS' ? (
                        <>
                            <Flex alignItems="center" gap={2} mt={2}>
                                <Text fontWeight="bold" fontSize={'14px'}>Instant form</Text>
                                <Tooltip
                                    borderRadius={5}
                                    label={
                                        <Box fontSize="sm" p="5px">
                                            <Text>Make connections with people by letting them send contact information and other details to you through a form.</Text>
                                        </Box>
                                    }
                                    fontSize="md"
                                >
                                    <InfoOutlineIcon pointerEvents="all" />
                                </Tooltip>
                            </Flex>

                            {/* Table Layout */}
                            {filteredInstantForms?.length > 0 ? (
                                <RadioGroup onChange={(value) => formik.setFieldValue('creative.object_story_spec.link_data.call_to_action.value.lead_gen_form_id', value)} colorScheme="brand" mt={-2}>
                                    <Table variant="simple">
                                        <Thead>
                                            <Tr>
                                                <Th textTransform={'none'} color={'none'} fontSize="14px" p={-1}>Form title</Th>
                                                <Th textTransform={'none'} color={'none'} fontSize="14px">Creation date</Th>
                                            </Tr>
                                        </Thead>
                                        <Tbody>
                                            {filteredInstantForms?.map((form) => (
                                                <Tr key={form?.id}>
                                                    <Td p={-1}>
                                                        <Flex alignItems="center" gap={2}>
                                                            <Radio value={form?.id} />
                                                            <Text color={form.status === 'DRAFT' ? "gray.500" : "none"} fontSize={'12px'}>
                                                                {form?.name}
                                                            </Text>
                                                        </Flex>
                                                    </Td>
                                                    <Td>
                                                        <Text fontSize={'12px'}>
                                                            {new Date(form?.created_time).getFullYear()}-
                                                            {String(new Date(form?.created_time).getMonth() + 1).padStart(2, '0')}-
                                                            {String(new Date(form?.created_time).getDate()).padStart(2, '0')}
                                                        </Text>
                                                    </Td>
                                                </Tr>
                                            ))}
                                        </Tbody>
                                    </Table>
                                </RadioGroup>
                            ) : (
                                <Text fontSize="14px" color="gray.500">No form data available</Text>
                            )}
                            {formik.touched?.creative?.object_story_spec?.link_data?.call_to_action?.value?.lead_gen_form_id &&
                                formik.errors?.creative?.object_story_spec?.link_data?.call_to_action?.value?.lead_gen_form_id && (
                                    <Text fontSize="12px" color="red.500">
                                        {formik.errors.creative.object_story_spec.link_data.call_to_action.value.lead_gen_form_id}
                                    </Text>
                            )}
                        </>
                    ) : null}

                    {['PHONE_CALL', 'ON_PAGE', 'APP', 'WHATSAPP', 'ON_AD'].includes(selectedAdset?.destination_type) ? null :
                        <Flex direction="column" gap={1}>
                            <Text fontWeight="bold" fontSize={'14px'}>Display link</Text>
                            <Input
                                name="creative.object_story_spec.link_data.caption"
                                placeholder="Enter the link that you want to show on your ad"
                                bg="#fff"
                                size='sm'
                                borderRadius="md"
                                value={formik.values.creative.object_story_spec.link_data.caption}
                                onChange={formik.handleChange}
                            />
                        </Flex>
                    }   

                    {selectedAdset?.destination_type === 'APP' && objective === 'OUTCOME_APP_PROMOTION'  ? (
                        <>
                            <Flex direction="column" gap={1}>
                                <Flex alignItems="center" gap={2}>
                                    <Text fontWeight="bold" fontSize={'14px'}>Deferred deep link</Text>
                                    <Tooltip
                                        borderRadius={5}
                                        label={
                                            <Box fontSize="sm" p="5px">
                                                <Text fontWeight={'bold'}>Using a deferred deep link</Text><br></br>
                                                <Text mb={2}>A deferred deep link is a URL that sends people to your app in the respective app store. Once people install your app, the link will take them to a specific screen, such as a product page.</Text>
                                                <Text mb={2}>To use a deferred deep link, you need to first connect the Facebook SDK. You can use any of these link types:</Text>
                                                <Box>
                                                    <Text>* Android app link</Text>
                                                    <Text>* Custom URL scheme</Text>
                                                    <Text>* Facebook app link</Text>
                                                </Box>
                                            </Box>
                                        }
                                        fontSize="md"
                                    >
                                        <InfoOutlineIcon pointerEvents="all" />
                                    </Tooltip>
                                </Flex>
                                <Input
                                    name="creative.object_story_spec.link_data.link"
                                    placeholder="Enter a deferred deep link URL"
                                    bg="#fff"
                                    size='sm'
                                    borderRadius="md"
                                    value={formik.values.creative.object_story_spec.link_data.link}
                                    onChange={formik.handleChange}
                                />
                            </Flex>

                            <Flex direction="column" gap={1}>
                                <Flex alignItems="center" gap={2}>
                                    <Text fontWeight="bold" fontSize={'14px'}>Custom store listing</Text>
                                    <Tooltip
                                        borderRadius={5}
                                        label={
                                            <Box fontSize="sm" p="5px">
                                                <Text fontWeight={'bold'}>Using a custom store listing</Text><br></br>
                                                <Text mb={2}>A custom store listing ID sends people who click your ad to a landing page that you've customised in the Google Play Store.</Text>
                                                <Text mb={2}>Use this feature to create multiple custom product pages with different media and text that speak to your various audiences.</Text>
                                            </Box>
                                        }
                                        fontSize="md"
                                    >
                                        <InfoOutlineIcon pointerEvents="all" />
                                    </Tooltip>
                                </Flex>
                                <Input
                                    name="creative.app_product_page_id"
                                    placeholder="Enter custome store listing ID"
                                    bg="#fff"
                                    size='sm'
                                    borderRadius="md"
                                    value={formik.values.creative.app_product_page_id}
                                    onChange={formik.handleChange}
                                />
                            </Flex>
                        </>
                    ) : null}

                    {selectedAdset?.destination_type === 'APP' && ["OUTCOME_SALES", "OUTCOME_LEADS"].includes(objective) ? (
                        <>
                            <Flex direction="column" gap={1}>
                                <Flex alignItems="center" gap={2}>
                                    <Text fontWeight="bold" fontSize={'14px'}>Deep link</Text>
                                    <Text as="span" fontWeight="bold" color={'gray.600'}>Optional</Text>
                                    <Tooltip
                                        borderRadius={5}
                                        label={
                                            <Box fontSize="sm" p="5px">
                                                <Text>Send people to a specific place in your app. You can use an Apple universal link, Android App Link, custom URL scheme or Facebook App Link.</Text>
                                            </Box>
                                        }
                                        fontSize="md"
                                    >
                                        <InfoOutlineIcon pointerEvents="all" />
                                    </Tooltip>
                                </Flex>
                                <Input
                                    name="creative.object_story_spec.link_data.link"
                                    placeholder="Enter the deep link URL"
                                    bg="#fff"
                                    size='sm'
                                    borderRadius="md"
                                    value={formik.values.creative.object_story_spec.link_data.link}
                                    onChange={formik.handleChange}
                                />
                            </Flex>
                        </>
                    ) : null}
                </Flex>

                {['APP','WHATSAPP'].includes(selectedAdset?.destination_type) ? null :
                    <Flex direction={'column'} gap={2} borderRadius="md" bg={background} p={4} mb={4}>
                        <Text fontWeight={'bold'}>Tracking</Text>
                        <Flex direction="column" gap={1}>
                            <Flex alignItems={'center'}>
                                <Text mb={2} fontWeight="bold">
                                    URL parameters{" "}
                                    {/* <Text as="span" fontWeight="bold" color={'gray.600'} mr={1}>.</Text> */}
                                    <Text as="span" fontWeight="bold" color={'gray.600'}>Optional</Text>
                                </Text>
                                <Tooltip
                                    borderRadius={5}
                                    label={
                                        <Box fontSize="sm" p={'5px'}>
                                            <Text >
                                                Add parameters to the end of your website URL to track where your visitors are coming from.
                                            </Text>
                                        </Box>
                                    }
                                    fontSize="md"
                                >
                                    <InfoOutlineIcon pointerEvents="all" ml={2} mb={2} />
                                </Tooltip>
                            </Flex>
                            <Input
                                name="creative.url_tags"
                                placeholder="key1=value1&key2=value2"
                                bg="#fff"
                                size='sm'
                                borderRadius="md"
                                value={formik.values.creative.url_tags}
                                onChange={formik.handleChange}
                            />
                            <Flex mt={2}>
                                <Button onClick={() => {
                                    setUrlParamModalOpen(true)
                                }}
                                    variant="link"
                                    color='brand'>
                                    <Text fontSize={'12px'} >{'Build a URL parameter'}</Text>
                                </Button>
                            </Flex>
                            {formik.touched.creative?.url_tags && formik.errors.creative?.url_tags && (
                                <Text fontSize={"12px"} color="red.500">{formik.errors.creative?.url_tags}</Text>
                            )}
                        </Flex>
                    </Flex>
                }

                <Flex direction={'column'} gap={2} borderRadius="md" bg={background} p={4} mb={4}>
                    <Flex direction="column" gap={1}>
                        <Text fontWeight="bold">CPA</Text>
                        <Input
                            name="cpa"
                            placeholder="Enter CPA"
                            bg="#fff"
                            size='sm'
                            borderRadius="md"
                            value={formik.values.cpa}
                            onBlur={formik.handleBlur}
                            onChange={formik.handleChange}
                        />
                        {formik.touched.cpa && formik.errors.cpa && (
                            <Text fontSize={"12px"} color="red.500">{formik.errors.cpa}</Text>
                        )}
                    </Flex>
                </Flex>

                <Flex mb={4}>
                    <Button
                        size="sm"
                        colorScheme="brand"
                        isLoading={formik.isSubmitting}
                        type="submit"
                        onClick={onSave}
                    >
                        Save
                    </Button>
                </Flex>
            </form>

            <Modal isOpen={isUrlModalOpen} onClose={() => setUrlModalOpen(false)} scrollBehavior={"inside"}
                size={"2xl"}
                isCentered={true}>
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader css={{ boxShadow: '0 0px 5px rgba(0, 0, 0, 0.1)' }}>Build a URL parameter</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                        <BuildUrlParamsUpdate link={formik.values.creative.object_story_spec.link_data} onClose={() => setUrlModalOpen(false)} onUrlChange={handleUrlChange} />
                    </ModalBody>
                </ModalContent>
            </Modal>

            <Modal isOpen={isUrlParamModalOpen} onClose={() => setUrlParamModalOpen(false)} scrollBehavior={"inside"}
                size={"2xl"}
                isCentered={true}>
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader css={{ boxShadow: '0 0px 5px rgba(0, 0, 0, 0.1)' }}>Build a URL parameter</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                        <UrlParametersUpdate link={formik.values.creative} onClose={() => setUrlParamModalOpen(false)} onUrlChange={handleUrlParamChange} />
                    </ModalBody>
                </ModalContent>
            </Modal>

            <Modal isOpen={isEditMediaOpen} onClose={OnEditMediaClose} scrollBehavior={"inside"} size={"5xl"} isCentered={true}>
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader>Select media for placements</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                        <Flex gap={6} justifyContent={'center'}>
                            {selectedMediaUrls?.map(({ placement, url, source, mediaType }) => {
                                if ((selectedAdset?.destination_type === 'APP' &&
                                    ["OUTCOME_SALES", "OUTCOME_LEADS"].includes(objective) || selectedAdset?.destination_type === 'WHATSAPP') &&
                                    placement !== 'square' &&
                                    placement !== 'vertical'
                                ) return null;

                                return(
                                <Box
                                    key={`${placement}`}
                                    border="1px solid"
                                    borderColor={'gray.100'}
                                    borderRadius="md"
                                    p={2}
                                    width={'240px'}
                                    height={
                                    placement === 'square'
                                        ? '300px'
                                        : placement === 'vertical'
                                        ? '530px'
                                        : '230px'
                                    }
                                    display="flex"
                                    flexDirection="column"
                                    gap={2}
                                >
                                    <Text fontWeight="bold" textTransform="capitalize">
                                        {placement}
                                    </Text>
                                    {source ? (
                                        <Box
                                        width="220px"
                                        height={
                                            placement === 'square'
                                            ? '200px'
                                            : placement === 'vertical'
                                                ? '440px'
                                                : '120px'
                                        }
                                        display="flex"
                                        alignItems="center"
                                        justifyContent="center"
                                        bg="gray.200"
                                        borderRadius="md"
                                        >
                                        <Box
                                            as="video"
                                            controls
                                            src={source}
                                            maxWidth="100%"
                                            maxHeight="100%"
                                            style={{ objectFit: 'contain', objectPosition: 'center' }}
                                        />
                                    </Box>
                                    ) : (
                                    <Box
                                        width="220px"
                                        height={
                                        placement === 'square'
                                            ? '200px'
                                            : placement === 'vertical'
                                            ? '430px'
                                            : '120px'
                                        }
                                        display="flex"
                                        alignItems="center"
                                        justifyContent="center"
                                        bg="gray.200"               
                                        borderRadius="md"
                                    >
                                        <Image
                                            src={url}
                                            alt={placement}
                                            maxWidth="100%"
                                            maxHeight="100%"
                                            objectFit="contain"      
                                            objectPosition="center"  
                                        />
                                    </Box>
                                    )}
                                    <Flex>
                                    <Button
                                        size="sm"
                                        variant={'solid'}
                                        colorScheme={'gray'}
                                        mt={2}
                                        leftIcon={<FaExchangeAlt />}
                                        onClick={() => handleReplaceImage(placement, mediaType)}
                                    >
                                        Replace
                                    </Button>
                                    </Flex>
                                </Box>
                            )})}
                        </Flex>
                    </ModalBody>
                    <ModalFooter gap={2}>
                        <Button 
                            colorScheme="gray"
                            variant="solid"
                            size={'sm'} 
                            onClick={OnEditMediaClose}
                        >
                        Cancel
                        </Button>
                        <Button colorScheme="brand" size={'sm'} onClick={OnEditMediaClose}>
                            Save
                        </Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>

            <Modal
                isOpen={isAiImageModaOpen}
                onClose={onAiImageModalClose} scrollBehavior={"inside"}
                size={"5xl"}
                isCentered={true}
                closeOnOverlayClick={false}
                closeOnEsc={false}
            >
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader>
                        <Flex gap={2} direction={'column'}>
                            <Flex alignItems={'center'} gap={2}>
                                <BsStars />
                                <Text>AI Image Generation</Text>
                                <Tooltip
                                    borderRadius={5}
                                    label={
                                        <Flex direction={'column'} gap={2} fontSize="sm" p="5px">
                                            <Text fontWeight={'bold'}>Generated with AI</Text>
                                            <Text>AI-generated image variations are inspired by your original asset. Adding multiple image options to your ad can help tailor creatives to different audiences, reduce creative fatigue, and improve overall performance.</Text>
                                            <Flex direction={'column'} gap={2}>
                                                <Text fontWeight={'bold'}>Types of AI Variations:</Text>
                                                <Text>Background Variation: Your product is placed in different, relevant environments.</Text>
                                                <Text>Creative Variation: Entirely new visuals generated based on your original creative.</Text>
                                            </Flex>
                                            <Text>Note: Hustle does not guarantee the completeness, accuracy, or reliability of AI-generated images.</Text>
                                        </Flex>
                                    }
                                    fontSize="md"
                                >
                                    <InfoOutlineIcon pointerEvents="all" />
                                </Tooltip>
                            </Flex>
                        </Flex>
                    </ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                        <AiImageModal
                            selectedAdAccounts={[{
                                id: adsAccountData?.id,
                                adsAccountId: adsAccountData?.account_id,
                                adsAccountName: adsAccountData?.name,
                                businessName: adsAccountData?.business?.name,
                                businessId: adsAccountData?.business?.id
                            }]}
                            onClose={onAiImageModalClose}
                            onUploadComplete={handleAiUploadedMedia}
                        />
                    </ModalBody>
                </ModalContent>
            </Modal>

            {/* Upload Video Modal */}
            <Modal
                size={"6xl"}
                isCentered={true}
                isOpen={isAiVideoModalOpen}
                scrollBehavior={"inside"}
                onClose={onAiVideoModalClose}
                closeOnOverlayClick={false}
                closeOnEsc={false}
            >
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader>
                        <Flex gap={2} direction={'column'}>
                            <Flex alignItems={'center'} gap={2}>
                                <BsStars />
                                <Text>AI Video Generation</Text>
                                <Tooltip
                                    borderRadius={5}
                                    label={
                                        <Flex direction={'column'} gap={2} fontSize="12px" p="5px">
                                            <Text fontWeight={'bold'}>Generated with AI</Text>
                                            <Text>AI-generated video variations are inspired by your original asset. Adding multiple image options to your ad can help tailor creatives to different audiences, reduce creative fatigue, and improve overall performance.</Text>
                                            <Flex direction={'column'} gap={2}>
                                                <Text fontWeight={'bold'}>Types of AI Variations:</Text>
                                                <Text>Background Variation: Your product is placed in different, relevant environments.</Text>
                                                <Text>Creative Variation: Entirely new visuals generated based on your original creative.</Text>
                                            </Flex>
                                            <Text>Note: Hustle does not guarantee the completeness, accuracy, or reliability of AI-generated videos.</Text>
                                        </Flex>
                                    }
                                    fontSize="md"
                                >
                                    <InfoOutlineIcon pointerEvents="all" />
                                </Tooltip>
                            </Flex>
                        </Flex>
                    </ModalHeader>
                    <ModalBody>
                        <AiVideoModal
                            isOpen={isAiVideoModalOpen}
                            selectedAdAccounts={[{
                                id: adsAccountData?.id,
                                adsAccountId: adsAccountData?.account_id,
                                adsAccountName: adsAccountData?.name,
                                businessName: adsAccountData?.business?.name,
                                businessId: adsAccountData?.business?.id
                            }]}
                            onClose={() => {
                                onAiVideoModalClose();
                            }}
                        />
                    </ModalBody>
                </ModalContent>
            </Modal>

            <MessageTemplateModal
                isOpen={isMessageModalOpen}
                onClose={onMessageModalClose}
                accountId={''}
                welcomeData={formik.values.page_welcome_message}
                onSave={(updatedData) => {
                    formik.setFieldValue('page_welcome_message', updatedData);
                    onMessageModalClose();
                }}
            />

            <Modal
                isOpen={isCreativeModalOpen}
                onClose={() => {
                    onCreativeModalClose();
                    setMediaType(null);
                }}
                isCentered
                closeOnOverlayClick={false}
                closeOnEsc={false}
            >
                <ModalOverlay />
                <ModalContent maxW={{ base: "100vw", md: "80vw" }} minH="80vh">
                <Divider />
                <ModalBody p={0}>
                    <Flex minH="80vh" w="100%">
                    {/* Sidebar */}
                    <Box
                        w={{ base: "260px", md: "200px" }}
                        bgGradient={bgGradient}
                        borderRight="1px solid"
                        borderColor={useColorModeValue("gray.200", "whiteAlpha.300")}
                        px={4}
                        py={3}
                    >
                        <Text fontWeight={"bold"} mb={4}>
                        Set up your creative
                        </Text>
                        <ButtonGroup orientation="vertical" spacing={3} display="flex" flexDir="column">
                        <StepButton isActive={activeStep === "Media"} onClick={() => setActiveStep("Media")}>
                            Media
                        </StepButton>
                        <Tooltip
                            label="Finish the Media step to proceed to the Replace."
                            isDisabled={hasSelectedFiles}
                            placement="bottom"
                            fontSize={'12px'}
                            hasArrow
                            >
                            <span>
                                <StepButton
                                    isActive={activeStep === "Replace"}
                                    onClick={() => setActiveStep("Replace")}
                                    isDisabled={!hasSelectedFiles}
                                >
                                Replace
                                </StepButton>
                            </span>
                        </Tooltip>
                        </ButtonGroup>
                    </Box>

                    {/* Main content area */}
                    <Box flex="1" py={3} px={2}>
                        {/* Dynamic header with close button */}
                        {(() => {
                        const meta = getStepMeta(activeStep, mediaType);
                        return (
                            <Box position="sticky" top={0} zIndex={1}>
                            <Flex>
                                <Flex gap={1} direction={"column"} flex={"98%"}>
                                <Text fontWeight={"bold"}>{meta.title}</Text>
                                <Text fontSize="12px">
                                    {meta.desc}
                                </Text>
                                </Flex>
                                <Flex flex={"2%"}>
                                <IconButton
                                    aria-label="Close"
                                    icon={<CloseIcon boxSize={3} />}
                                    variant="ghost"
                                    onClick={() => {
                                        onCreativeModalClose();
                                        setMediaType(null);
                                        setActiveStep('Media')
                                    }}
                                    size="sm"
                                    alignSelf="flex-start"
                                />
                                </Flex>
                            </Flex>
                            </Box>
                        );
                        })()}

                        {/* Step body (swap your real components in) */}
                        {activeStep === "Media" ? (
                        <DriveComponent
                            mediaType={mediaType}
                            selectedAdAccounts={[{
                                id: adsAccountData?.id,
                                adsAccountId: adsAccountData?.account_id,
                                adsAccountName: adsAccountData?.name,
                                businessName: adsAccountData?.business?.name,
                                businessId: adsAccountData?.business?.id
                            }]}
                            uploadPurpose="update"
                            onSubmit={handleMediaSelect}
                            activeStep={"Media"}
                            setActiveStep={setActiveStep}
                            setHasSelectedFiles={setHasSelectedFiles}
                            onClose={() => {
                                onCreativeModalClose();
                                setMediaType(null);
                                setActiveStep('Media');
                                setHasSelectedFiles(false)
                            }}
                        />
                        ) : (
                        <ReplaceComponentForSingle
                            selectedMediaUrls={selectedMediaUrls}
                            setselectedMediaUrls={setselectedMediaUrls}
                            mediaType={mediaType}
                            onClose={() => {
                                onCreativeModalClose();
                                setMediaType(null);
                                setActiveStep('Media');
                            }}
                            setActiveStep={setActiveStep}
                            setFieldValue={formik.setFieldValue}
                            selectedAdAccounts={[{
                                id: adsAccountData?.id,
                                adsAccountId: adsAccountData?.account_id,
                                adsAccountName: adsAccountData?.name,
                                businessName: adsAccountData?.business?.name,
                                businessId: adsAccountData?.business?.id
                            }]}
                        />
                        )}
                    </Box>
                    </Flex>
                </ModalBody>
                </ModalContent>
            </Modal>

            <ReplaceDriveModal
                isDriveModalOpen={isReplaceModalOpen}
                selectedAdAccounts={[{
                    id: adsAccountData?.id,
                    adsAccountId: adsAccountData?.account_id,
                    adsAccountName: adsAccountData?.name,
                    businessName: adsAccountData?.business?.name,
                    businessId: adsAccountData?.business?.id
                }]}
                onClose={() => {
                    OnReplaceModalClose();
                    setMediaType(null);
                }}
                onSubmit={handleImageSelectedFromReplaceDrive}
                uploadPurpose="update"
                mediaType={mediaType}
            />
        </Box>
    );
};

export default CreateSingleAdForm;
